/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
import { List, Map, fromJS } from 'immutable';
import { LOGIN, LOGOUT } from 'actions/actions';

import { DELETE_FROM_COLLECTION, PASSES, TENANTS } from 'actions/collections';
import { UPDATE_ITEM } from 'actions/items';


export function clearAllOnLogout(state = {}, action) {
  switch (action.type) {
    case LOGIN:
    case LOGOUT:
      return {};
    default:
      return state;
  }
}

const updateItems = (state, collectionName, updateItem) =>
  Object.assign({}, state, {
    collections: state.collections.updateIn([collectionName, 'items'], List(), items => items.map(updateItem)),
    items: state.items.update(collectionName, Map(), updateItem),
  });

export function updateNestedCollections(state = {}, action) {
  /* Currently this is just imperative code, but as more nested objects need to
    respond to delete/updates, this would be better implemented by iterating over
    a data structure specifying the object relationships. Eg:

    const NESTED_OBJECTS = {
      [PASSES]: [[TENANTS, ['passes'], { multiple: true }]],
      ...
    };
  */

  const { type, meta, payload } = action;

  if (type === DELETE_FROM_COLLECTION.SUCCESS || type === UPDATE_ITEM.SUCCESS) {
    const isDelete = type === DELETE_FROM_COLLECTION.SUCCESS;
    const { id, collectionName } = meta;

    if (collectionName === PASSES) {
      return updateItems(
        state,
        TENANTS,
        item => item.update(
          'passes',
          passes =>
            (isDelete
              ? passes && passes.filterNot(pass => pass.get('id') === id)
              : passes && passes.map(pass => (pass.get('id') === id ? fromJS(payload) : pass))
            ),
        ),
      );
    }
  }

  return state;
}

export default 'default';
